Vue.component("datepicker", {
    props: ['selected', 'lang', 'id'],
    data: function () {
        return {
        };
    },
    mounted: function () {
        var _this = this;
        $('#' + _this.id).datepicker({
            onSelect: function (selectedDate, datePicker) {
                _this.selected = selectedDate;
                _this.$emit('update:selected', _this.selected);
            },
            autoClose: true
        });
    },
    template: '<div class=\"datepicker-wrap\">\
                 <input type=\"text\" class=\"form__input\" :id=\"id\" :data-language=\"lang\" >\
                 <svg class=\"form__datepicker-icon\">\
                     <use xlink:href=\"~/m/i/icons.svg#symbol-calendar\"></use>\
                 </svg>\
             </div>\
'
});